/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import EmptyFolder from 'assets/svg/empty_folder.svg';
import { DragDropContext } from 'react-beautiful-dnd';
import { DocumentsContext } from '../provider/DocumentsProvider';
import FoldersList from './FoldersList';
import ContentsList from './ContentList';

const FolderContent = React.memo(({ selectedFolder }) => {
  const {
    literals,
    actualFolder,
    setActualFolder,

    subfolders,
    content,

    loading,
    unauthorized,
  } = useContext(DocumentsContext);

  useEffect(() => {
    setActualFolder(selectedFolder);
  }, [selectedFolder, setActualFolder]);

  if (!actualFolder && !loading) {
    return (
      <div className='panel-empty-message'>
        <img src={EmptyFolder} alt={literals.noFolderSelected} />
        <p>{literals.noFolderSelected}</p>
      </div>
    );
  }

  if (!loading && !subfolders?.length && !content?.items?.length) {
    return (
      <div className='panel-empty-message'>
        <img src={EmptyFolder} alt={literals.emptyFolder} />
        <p>{unauthorized ? literals.noFolderPermissions : literals.emptyFolder}</p>
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={() => { }}>
      <div className='folder'>
        <FoldersList />
        <ContentsList />
      </div>
    </DragDropContext>
  );
}, (prevProps, nextProps) => prevProps.selectedFolder.id === nextProps.selectedFolder.id);

FolderContent.propTypes = {
  selectedFolder: PropTypes.object,
};

export default FolderContent;
